import { Box, Stack, Typography } from "@mui/material";
import moment from "moment";
import { supplierUi } from "../../shared/supplierUi";

const emptyValue = (val) => val === null || val === undefined || val === "";

const DisplayAddressInfo = ({ labelData, values }) => {
	return (
		<Box
			width="100%"
			display="grid"
			gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }}
			columnGap={3}
			rowGap={2.5}>
			{Object.keys(labelData).map((colName) => {
				const isDate = labelData[colName]?.isDate;
				const isAddress = labelData[colName]?.isAddress;
				const raw = values?.[colName];
				const display = emptyValue(raw)
					? "—"
					: isDate
					? moment(raw).format("DD-MM-YYYY")
					: String(raw);

				return (
					<Stack
						spacing={0.5}
						key={labelData[colName].name}
						sx={{ gridColumn: isAddress ? "1 / -1" : "auto", minWidth: 0 }}>
						<Typography
							variant="caption"
							sx={{
								color: supplierUi.textMuted,
								fontWeight: 500,
								letterSpacing: 0.3,
								textTransform: "uppercase",
								fontSize: 13,
							}}>
							{labelData[colName].name}
						</Typography>
						<Typography
							sx={{
								fontSize: 17,
								fontWeight: 500,
								color: display === "—" ? supplierUi.textMuted : supplierUi.textPrimary,
								lineHeight: 1.45,
								whiteSpace: isAddress ? "pre-wrap" : "normal",
								wordBreak: "break-word",
							}}>
							{display}
						</Typography>
					</Stack>
				);
			})}
		</Box>
	);
};

export default DisplayAddressInfo;
